<template>
  <div class="listo">
    <div class="header-container">
      <header-bar
        :title="title"
        :back-link="backLink"
      />
    </div>
    <item-list
      v-show="exhibitsLoaded"
      :items="items"
      @item-clicked="handleClick"
    />
  </div>
</template>

<script>
import ExhibitData from '../mixins/ExhibitData.vue'

export default {
    name: 'ExhibitList',
    mixins: [
      ExhibitData
    ],
    props: {
      exhibitGroup: {
        type: [String, Boolean],
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      routeName: {
        type: String,
        required: true
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    computed: {
        items() {
          if (this.exhibitsLoaded) {
            const items = this.$store.getters.exhibitsGroupedArray[this.exhibitGroup]
            return this.exhibitGroup ? items : this.$store.getters.allExhibits
          }
          return []
        }
    },
    methods: {
      handleClick(item) {
        this.$router.push({name: this.routeName, params: { exhibitslug: item.friendly } })
      }
    }
}
</script>

<style lang="scss" scoped>
.header-container {
    background: black;
}
</style>